import { LiveKitRoom } from '@livekit/components-react'
import React from 'react'
import { observer } from 'mobx-react-lite'
import { type Room } from 'livekit-client'
import type { IResponseGettestSession } from 'entities/AICalling/api/types'
import { type DeviceSettingsStore } from 'entities/DeviceSettings'
import { LiveKitContent } from './LiveKitContent'

export const LiveKit = observer(
  ({
    data,
    room,
    deviceSettingsStore,
    loading,
  }: {
    data: IResponseGettestSession
    room: Room
    deviceSettingsStore: DeviceSettingsStore
    loading: boolean
  }) => {
    return (
      <div style={{ display: 'none' }}>
        <LiveKitRoom token={data.token} serverUrl={data.livekit_url} connect={true} room={room}>
          <LiveKitContent loading={loading} deviceSettingsStore={deviceSettingsStore} />
        </LiveKitRoom>
      </div>
    )
  }
)
